import { Card, CardBody, Col } from "reactstrap";
import { P } from "../../../../AbstractElements";
import { FontStyleTitle } from "../../../../Constants/Constants";
import { FontStyleData, FontStyleSubTitle } from "../../../../Data/UiKits/HelperClasses";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const FontStyle = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={FontStyleTitle} span={FontStyleSubTitle} />
        <CardBody>
          {FontStyleData &&
            FontStyleData.map((item, index) => (
              <P className={`f-s-${item}`} key={index}>
                {"This is a "} <strong>{`.f-s-${item}`}</strong> {"font-style"}
              </P>
            ))}
        </CardBody>
      </Card>
    </Col>
  );
};
export default FontStyle;
